<template>
  <v-container style="background-color: #DCEDC8" class="py-10 mt-10">
    <v-row>
      <v-col cols="12" sm="6">
        <v-img
          :lazy-src="img"
          max-height="400"
          max-width="400"
          class="mx-auto my-auto"
          src="./../assets/VIKASH.jpg"
          style="border-radius: 25% 10% 25% 10%; border: 5px solid #311B92;"
        ></v-img>
      </v-col>
      <v-col cols="12" sm="6">
        <v-card class="mx-auto" flat style="width: 100%; background-color: #DCEDC8" min-height="400">
          <!-- <v-card-title> -->
          <p class="text-h4 text-center mb-0" style="color: #311B92">
            <span class="font-weight-medium text-decoration-overline">Vikash Kumar</span> <br>
            <span class="font-weight-thin text-decoration-underline">Fullstack Developer</span>
          </p>
          <v-card-text>
            <p class="text-h6" style="color: #7986CB">
             If I say about me, I am a <strong>Fullstack Developer</strong>. I have done my B.Tech from <strong>SAMCET, Bhopal</strong> in 2017-21 batch. 
             In my college days I have done many projects related to <strong>Web Development, Data Analisys, Machine Learning and Database</strong>.
             In 2021, I joined <strong>Thinkitive Technology</strong> and since I am working on industries projects.
            </p>
          </v-card-text>
          <v-card-actions>
              <v-btn text icon color="blue darken-2" v-bind:href="linkedin" target="_blank">
                <v-icon>mdi-linkedin</v-icon>
              </v-btn>
              <v-btn text icon color="blue darken-2" v-bind:href="github" target="_blank">
                <v-icon>mdi-github</v-icon>
              </v-btn>
              <v-btn text icon color="blue darken-2" v-bind:href="linkedin" target="_blank">
                <v-icon>mdi-facebook</v-icon>
              </v-btn>
              <v-btn color="light-blue lighten-2" text to="/contact">Contact</v-btn>
          </v-card-actions>
        </v-card>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
export default {
  data() {
    return {
      linkedin: "https://www.linkedin.com/in/vikash-kumar-a40860176",
      github: "https://github.com/vikash8507",
      img: "https://media-exp1.licdn.com/dms/image/C4D03AQG-L1So9bIeZg/profile-displayphoto-shrink_800_800/0/1613386014274?e=1647475200&v=beta&t=elRXmRXyBfX1nFGGjXujFVbQARjr_hb7RnAesobx9QA"
    }
  }
}
</script>